import { api, apiFile, base_url_v1, base_url_v2 } from "./api";
import { convertStringDateToDate } from "../utils";

export const RollCallApi = async (parms: any) => {
    let url_parms = '';
    for (let [key, value] of Object.entries(parms)) {
        if (key != 'user') {
            url_parms = `${url_parms}&${key}=${value}`
        }
        else if (key == 'user' && Array.isArray(value)) {
            for (let i of value) {
                url_parms = `${url_parms}&user_ids[]=${i}`
            }
        }
    }
    const data = await api({ url: `${base_url_v2}company/roll_calls?${url_parms}`, method: "GET", token: true })
    return data;
}



export const AddRollCallApi = async (formRef: any, startDateRef: any, endDateRef: any) => {
    let postData = JSON.stringify({
        'user_id': +formRef.current['employee'].value,
        'qr_code_id': +formRef.current['location'].value,
        'entrance': `${convertStringDateToDate(startDateRef.current.state.initialValue._d)} ${formRef.current['start_hours'].value}:${formRef.current['start_min'].value}:00`,
        'exit': `${convertStringDateToDate(endDateRef.current.state.initialValue._d)} ${formRef.current['end_hours'].value}:${formRef.current['end_min'].value}:00`,
    })
    const data = await api({ url: `${base_url_v2}company/roll_calls`, method: "POST", token: true, body: postData })
    return data;
}

export const EditRollCallApi = async (formRef: any, defualtDate: any, userInfo: any) => {
    let postData = JSON.stringify({
        'id': +userInfo.id,
        'user_id': +userInfo.user_id,
        'qr_code_id': +userInfo.qr_code_id,
        'entrance': `${defualtDate.start_date} ${formRef.current['start_hours'].value}:${formRef.current['start_min'].value}:00`,
        'exit': `${defualtDate.end_date} ${formRef.current['end_hours'].value}:${formRef.current['end_min'].value}:00`,
    })
    const data = await api({ url: `${base_url_v2}company/roll_calls/${userInfo.id}`, method: "PATCH", token: true, body: postData })
    return data;
}

export const GetSingleRollCallApi = async (id: any) => {
    const data = await api({ url: `${base_url_v2}company/roll_calls/${id}`, method: "GET", token: true })
    return data;
}

export const DeleteRollCallApi = async (id: any) => {
    const data = await api({ url: `${base_url_v2}company/roll_calls/${id}`, method: "DELETE", token: true })
    return data;
}

export const RollCallExport = async (parms: any, format: string) => {
    let url_parms = '';
    for (let [key, value] of Object.entries(parms)) {
        if (key != 'user') {
            url_parms = `${url_parms}&${key}=${value}`
        }
        else if (key == 'user' && Array.isArray(value)) {
            for (let i of value) {
                url_parms = `${url_parms}&user_ids[]=${i}`
            }
        }
    }
    const data = await apiFile({ url: `${base_url_v2}company/attendances/export?format=${format}${url_parms}`, method: "GET", token: true })
    return data;
}




// ######### Delay Api ##########

export const DelayApi = async (parms: any) => {
    let url_parms = '';
    for (let [key, value] of Object.entries(parms)) {
        if (key != 'user') {
            url_parms = `${url_parms}&${key}=${value}`
        }
        else if (key == 'user' && Array.isArray(value)) {
            for (let i of value) {
                url_parms = `${url_parms}&user_ids[]=${i}`
            }
        }
    }
    const data = await api({ url: `${base_url_v2}company/rollcall-reasons?${url_parms}`, method: "GET", token: true })
    return data;
}


export const DelayChangeStatusApi = async (id: any, status: any) => {
    let postData = JSON.stringify({
        'status': +status,
    })
    const data = await api({ url: `${base_url_v2}company/rollcall-reasons/${id}`, method: "PATCH", token: true, body: postData })
    return data;
}

export const DelayExport = async (parms: any, format: string) => {
    let url_parms = '';
    for (let [key, value] of Object.entries(parms)) {
        if (key != 'user') {
            url_parms = `${url_parms}&${key}=${value}`
        }
        else if (key == 'user' && Array.isArray(value)) {
            for (let i of value) {
                url_parms = `${url_parms}&user_ids[]=${i}`
            }
        }
    }
    const data = await apiFile({ url: `${base_url_v2}company/rollcall-reasons/export?format=${format}${url_parms}`, method: "GET", token: true })
    return data;
}


// ######### Overtime Api ##########

export const OverTimeApi = async (parms: any) => {
    let url_parms = '';
    for (let [key, value] of Object.entries(parms)) {
        if (key != 'user') {
            url_parms = `${url_parms}&${key}=${value}`
        }
        else if (key == 'user' && Array.isArray(value)) {
            for (let i of value) {
                url_parms = `${url_parms}&user_ids[]=${i}`
            }
        }
    }
    const data = await api({ url: `${base_url_v2}company/overtimes?${url_parms}`, method: "GET", token: true })
    return data;
}


export const OverTimeChangeStatusApi = async (id: any, status: any, withReason: any, formReason: any) => {
    let postData: any = {
        'status': +status,
    }
    if (withReason == 1) {
        postData['employer_reason'] = formReason.current['employer_reason'].value
    }
    const data = await api({ url: `${base_url_v2}company/overtimes/${id}`, method: "PATCH", token: true, body: JSON.stringify(postData) })
    return data;
}

export const OverTimeExport = async (parms: any, format: string) => {
    let url_parms = '';
    for (let [key, value] of Object.entries(parms)) {
        if (key != 'user') {
            url_parms = `${url_parms}&${key}=${value}`
        }
        else if (key == 'user' && Array.isArray(value)) {
            for (let i of value) {
                url_parms = `${url_parms}&user_ids[]=${i}`
            }
        }
    }
    const data = await apiFile({ url: `${base_url_v2}company/overtimes/export?format=${format}${url_parms}`, method: "GET", token: true })
    return data;
}



// ######### Absence Api ##########

export const AbsenceApi = async (parms: any) => {
    let url_parms = '';
    for (let [key, value] of Object.entries(parms)) {
        if (key != 'user') {
            url_parms = `${url_parms}&${key}=${value}`
        }
        else if (key == 'user' && Array.isArray(value)) {
            for (let i of value) {
                url_parms = `${url_parms}&user_ids[]=${i}`
            }
        }
    }
    const data = await api({ url: `${base_url_v2}company/absences?${url_parms}`, method: "GET", token: true })
    return data;
}


export const AbsenceExport = async (parms: any, format: string) => {
    let url_parms = '';
    for (let [key, value] of Object.entries(parms)) {
        if (key != 'user') {
            url_parms = `${url_parms}&${key}=${value}`
        }
        else if (key == 'user' && Array.isArray(value)) {
            for (let i of value) {
                url_parms = `${url_parms}&user_ids[]=${i}`
            }
        }
    }
    const data = await apiFile({ url: `${base_url_v2}company/absences/export?format=${format}${url_parms}`, method: "GET", token: true })
    return data;
}



// ######### Vacation Api ##########

export const VacationApi = async (parms: any) => {
    let url_parms = '';
    for (let [key, value] of Object.entries(parms)) {
        if (key != 'user') {
            url_parms = `${url_parms}&${key}=${value}`
        }
        else if (key == 'user' && Array.isArray(value)) {
            for (let i of value) {
                url_parms = `${url_parms}&user_ids[]=${i}`
            }
        }
    }
    const data = await api({ url: `${base_url_v2}company/vacations?${url_parms}`, method: "GET", token: true })
    return data;
}


export const VacationChangeStatusApi = async (id: any, status: any, withReason: any, formReason: any) => {
    let postData: any = {
        'status': +status,
    }
    if (withReason == 1) {
        postData['employer_reason'] = formReason.current['employer_reason'].value
    }
    const data = await api({ url: `${base_url_v2}company/vacations/${id}`, method: "PATCH", token: true, body: JSON.stringify(postData) })
    return data;
}

export const VacationExport = async (parms: any, format: string) => {
    let url_parms = '';
    for (let [key, value] of Object.entries(parms)) {
        if (key != 'user') {
            url_parms = `${url_parms}&${key}=${value}`
        }
        else if (key == 'user' && Array.isArray(value)) {
            for (let i of value) {
                url_parms = `${url_parms}&user_ids[]=${i}`
            }
        }
    }
    const data = await apiFile({ url: `${base_url_v2}company/vacations/export?format=${format}${url_parms}`, method: "GET", token: true })
    return data;
}



export const DeleteVacationApi = async (id: any) => {
    const data = await api({ url: `${base_url_v2}company/vacations/${id}`, method: "DELETE", token: true })
    return data;
}



export const GetVacationReasonsApi = async () => {
    const data = await api({ url: `${base_url_v2}company/vacation-reasons`, method: "GET", token: true })
    return data;
}

export const AddVacationApi = async (formRef: any, startDateRef: any, endDateRef: any, singleDateRef: any, selectType: any) => {
    let postData: any = {
        'user_id': +formRef.current['employee'].value,
        'reason': formRef.current['reasons'].value,
        'type': +selectType,
        'description': formRef.current['description'].value,
    }
    if (selectType == 1) {
        postData['date_from'] = `${convertStringDateToDate(singleDateRef.current.state.initialValue._d)} ${formRef.current['start_hours'].value}:${formRef.current['start_min'].value}:00`;
        postData['date_to'] = `${convertStringDateToDate(singleDateRef.current.state.initialValue._d)} ${formRef.current['end_hours'].value}:${formRef.current['end_min'].value}:00`;
    }
   
    
    if (selectType == 2) {
        postData['date_from'] = `${convertStringDateToDate(startDateRef.current.state.initialValue._d)} 00:00:00`;
        postData['date_to'] = `${convertStringDateToDate(endDateRef.current.state.initialValue._d)} 00:00:00`;
    }
    const data = await api({ url: `${base_url_v2}company/vacations`, method: "POST", token: true, body: JSON.stringify(postData) })
    return data;
}

export const GetSingleVacation = async (id: any) => {
    const data = await api({ url: `${base_url_v2}company/vacations/${id}`, method: "GET", token: true })
    return data;
}

export const EditVacationApi = async (formRef: any, defualtDate: any, userInfo: any) => {
    let postData: any = {
        'user_id': +userInfo.user_id,
        'reason': formRef.current['reasons'].value,
        'type':  +userInfo.type,
        'description': formRef.current['description'].value,
    }
    if (userInfo.type == 1) {
        postData['date_from'] = `${defualtDate.start_date} ${formRef.current['start_hours'].value}:${formRef.current['start_min'].value}:00`;
        postData['date_to'] = `${defualtDate.start_date} ${formRef.current['end_hours'].value}:${formRef.current['end_min'].value}:00`;
    }
   
    if (userInfo.type == 2) {
        postData['date_from'] = `${defualtDate.start_date} 00:00:00`;
        postData['date_to'] = `${defualtDate.end_date} 00:00:00`;
    }
    const data = await api({ url: `${base_url_v2}company/vacations/${userInfo.id}`, method: "PATCH", token: true, body: JSON.stringify(postData) })
    return data;
}



